
  // Import moment and jQuery and set up globals before static scripts load
  import moment from 'moment';
  import $ from 'jquery';
  window.moment = moment;
  window.$ = $;
  window.jQuery = $;

  // Pre-configure PDF.js worker to prevent currentScript.src null error
  window.PDFJS = window.PDFJS || {};
  window.PDFJS.workerSrc = '/scripts/vendor/pdfviewer/custom/pdf.worker.js';
